export const isPylonAccessAllowed = () =>
  document.body.dataset.pylonDisabled !== "true";

export const setPylonAccessAllowed = (allowed: boolean) => {
  if (allowed) {
    delete document.body.dataset.pylonDisabled;
    return;
  }

  document.body.dataset.pylonDisabled = "true";
  window.Pylon?.("hide");
  window.Pylon?.("hideChatBubble");
};
